import { takeLatest, put,call, take, fork, } from 'redux-saga/effects';
import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from './authActionTypes';
import { setUserDetails } from '../actions/authAction';
import { AUTH_ACTIONS } from 'src/containers/auth-container/actions/AuthActions';
import { fetchUserDetailsAPI } from 'src/api/UserApi';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { ACCOUNT_ACTIONS } from 'src/containers/account-container/actions/AccountActions';

function* loginSuccessSaga(action) {
  yield put(setUserDetails( action.payload.user));
}

function* logoutSaga() {
  yield put(setUserDetails(null));
}

function* authSaga() {
  yield takeLatest(LOGIN_SUCCESS, loginSuccessSaga);
  yield takeLatest(LOGOUT, logoutSaga);
}


export function* fetchUserScopes({
  userId,
}) {
  try {
      const {
          data: {
              data,
          },
      } = yield call(fetchUserDetailsAPI, {
          userId,
      });

      yield put({
          type: AUTH_ACTIONS.FETCH_PERMISSION_SCOPES_SUCCESS,
          payload: {
              userScopes: data,
          },
      });
  }
  catch (error) {
      yield put(headerShowAction({
        
        data: "Something went wrong",
      }));

      console.error('LoginSaga', error);

      yield put({
          type: AUTH_ACTIONS.LOGIN_ERROR,
      });
  }
}

export function* fetchUserDetails({
  userId,
}) {
  try {
      const {
          data: {
              data,
          },
      } = yield call(fetchUserDetailsAPI, {
          userId,
      });
      yield put({
          type: AUTH_ACTIONS.FETCH_USER_DETAILS_SUCCESS,
          payload: {
              userDetails: data,
          },
      });

      yield put({
        type: ACCOUNT_ACTIONS.ACCOUNT_UPSERT_SUCCESS,
        data: {
            ...data.accountSettingInformation,
        },
    });

  }
  catch (error) {
      yield put(headerShowAction({
          data: error.response.data.data,
      }));

      console.error('LoginSaga', error);

      yield put({
          type: AUTH_ACTIONS.LOGIN_ERROR,
      });
  }
}

export default [
  takeFirstSagaUtil(AUTH_ACTIONS.FETCH_PERMISSION_SCOPES, fetchUserScopes),
  takeFirstSagaUtil(AUTH_ACTIONS.FETCH_USER_DETAILS, fetchUserDetails),
  authSaga,
];

